<template>
  <div class="mb-14">
    <v-row justify="center" class="text-center">
      <v-col sm="10" lg="12">
        <AvatarUpdate :runAlert="runAlert" />
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="12" sm="10" lg="6">
        <AddressUpdate :runAlert="runAlert" />
      </v-col>
      <v-col cols="12" sm="10" lg="6">
        <BasicInfoUpdate :runAlert="runAlert" />
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col sm="10" lg="12">
        <ProfessionalInfoUpdate :runAlert="runAlert" />
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col sm="10" lg="12">
        <PasswordUpdate :runAlert="runAlert" />
      </v-col>
    </v-row>
    <v-dialog v-model="dialogModal" width="500">
      <v-alert prominent :type="type">
        <v-row align="center">
          <v-col class="grow">{{ this.alertMessage }}</v-col>
          <v-col class="shrink">
            <v-btn color="white" light @click="dialogModal = false">Ok</v-btn>
          </v-col>
        </v-row>
      </v-alert>
    </v-dialog>
  </div>
</template>
<script>
import ProfessionalInfoUpdate from '@/components/account/update/ProfessionalInfoUpdate'
import BasicInfoUpdate from '@/components/account/update/BasicInfoUpdate'
import PasswordUpdate from '@/components/account/update/PasswordUpdate'
import AddressUpdate from '@/components/account/update/AddressUpdate'
import AvatarUpdate from '@/components/account/update/AvatarUpdate'

export default {
  data () {
    return {
      dialogModal: false,
      type: 'error',
      pageIndex: 1,
      alertMessage: 'Something went wrong, please try again'
    }
  },
  async mounted () {

  },
  methods: {
    /* insertCountryRecords (name, code) {
      const Countries = Parse.Object.extend('Countries')
      const query = new Countries()
      query.set('country_name', name)
      query.set('code', code)
      const acl = new Parse.ACL()
      acl.setPublicReadAccess(true)
      acl.setPublicWriteAccess(false)
      query.setACL(acl)
      return query.save({}, { useMasterKey: true })
        .then(entry => {
          console.log('done')
        })
    },
    insertStateRecords (name, countryCode, stateCode) {
      const States = Parse.Object.extend('States')
      const query = new States()
      query.set('state_name', name)
      query.set('country_code', countryCode)
      query.set('state_code', stateCode)
      const acl = new Parse.ACL()
      acl.setPublicReadAccess(true)
      acl.setPublicWriteAccess(false)
      query.setACL(acl)
      return query.save({}, { useMasterKey: true })
        .then(entry => {
          console.log('done')
        })
    },
    insertCitiesRecords (name, countryCode, stateCode) {
      const Cities = Parse.Object.extend('Cities')
      const query = new Cities()
      query.set('city_name', name)
      query.set('country_code', countryCode)
      query.set('state_code', stateCode)
      const acl = new Parse.ACL()
      acl.setPublicReadAccess(true)
      acl.setPublicWriteAccess(false)
      query.setACL(acl)
      return query.save({}, { useMasterKey: true })
        .then(entry => {
          console.log('done')
        })
    },

    async loadCOuntries () {
      const user = Parse.User.current()
      console.log(user, 'users')

      let $page_db = this.pageIndex
      let $limits = 100
      let $page = $page_db - 1
      let $count = 0
      let $start = $page * $limits
      let $end = ($page + 1) * $limits
      console.log(Cities.length, 'Cities')
      console.log($start,$end,$count)
      Cities.map((row, index) => {
        if ($count < $end && $count >= $start){
          console.log(index,$start,$end,$count)
          this.insertCitiesRecords(row.city_name, row.country_code, row.state_code)
          if (($end-1) ===index){
            this.pageIndex++
          }
        }
        $count++
       // console.log(row.city_name)
        // await this.insertCitiesRecords(row.city_name, row.country_code, row.state_code)
      })

       const states =
        [
          {
            _id: {
              $oid: '61ade3951d72c175ac638119'
            },
            name: 'Alberta',
            country_code: 'CA',
            state_code: 'AB'
          }, {
            _id: {
              $oid: '61ade3951d72c175ac63811a'
            },
            name: 'British Columbia',
            country_code: 'CA',
            state_code: 'BC'
          }, {
            _id: {
              $oid: '61ade3951d72c175ac63811b'
            },
            name: 'Manitoba',
            country_code: 'CA',
            state_code: 'MB'
          }, {
            _id: {
              $oid: '61ade3951d72c175ac63811c'
            },
            name: 'New Brunswick',
            country_code: 'CA',
            state_code: 'NB'
          }, {
            _id: {
              $oid: '61ade3951d72c175ac63811d'
            },
            name: 'Newfoundland and Labrador',
            country_code: 'CA',
            state_code: 'NL'
          }, {
            _id: {
              $oid: '61ade3951d72c175ac63811e'
            },
            name: 'Northwest Territories',
            country_code: 'CA',
            state_code: 'NT'
          }, {
            _id: {
              $oid: '61ade3951d72c175ac63811f'
            },
            name: 'Nova Scotia',
            country_code: 'CA',
            state_code: 'NS'
          }, {
            _id: {
              $oid: '61ade3951d72c175ac638120'
            },
            name: 'Nunavut',
            country_code: 'CA',
            state_code: 'NU'
          }, {
            _id: {
              $oid: '61ade3951d72c175ac638121'
            },
            name: 'Ontario',
            country_code: 'CA',
            state_code: 'ON'
          }, {
            _id: {
              $oid: '61ade3951d72c175ac638122'
            },
            name: 'Prince Edward Island',
            country_code: 'CA',
            state_code: 'PE'
          }, {
            _id: {
              $oid: '61ade3951d72c175ac638123'
            },
            name: 'Quebec',
            country_code: 'CA',
            state_code: 'QC'
          }, {
            _id: {
              $oid: '61ade3951d72c175ac638124'
            },
            name: 'Saskatchewan',
            country_code: 'CA',
            state_code: 'SK'
          }, {
            _id: {
              $oid: '61ade3951d72c175ac638125'
            },
            name: 'Yukon',
            country_code: 'CA',
            state_code: 'YT'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac638128'
            },
            name: 'Alabama',
            country_code: 'US',
            state_code: 'AL'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac638129'
            },
            name: 'Alaska',
            country_code: 'US',
            state_code: 'AK'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac63812a'
            },
            name: 'American Samoa',
            country_code: 'US',
            state_code: 'AS'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac63812b'
            },
            name: 'Arizona',
            country_code: 'US',
            state_code: 'AZ'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac63812c'
            },
            name: 'Arkansas',
            country_code: 'US',
            state_code: 'AR'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac63812d'
            },
            name: 'Baker Island',
            country_code: 'US',
            state_code: 'UM-81'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac63812e'
            },
            name: 'California',
            country_code: 'US',
            state_code: 'CA'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac63812f'
            },
            name: 'Colorado',
            country_code: 'US',
            state_code: 'CO'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac638130'
            },
            name: 'Connecticut',
            country_code: 'US',
            state_code: 'CT'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac638131'
            },
            name: 'Delaware',
            country_code: 'US',
            state_code: 'DE'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac638132'
            },
            name: 'District of Columbia',
            country_code: 'US',
            state_code: 'DC'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac638133'
            },
            name: 'Florida',
            country_code: 'US',
            state_code: 'FL'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac638134'
            },
            name: 'Georgia',
            country_code: 'US',
            state_code: 'GA'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac638135'
            },
            name: 'Guam',
            country_code: 'US',
            state_code: 'GU'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac638136'
            },
            name: 'Hawaii',
            country_code: 'US',
            state_code: 'HI'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac638137'
            },
            name: 'Howland Island',
            country_code: 'US',
            state_code: 'UM-84'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac638138'
            },
            name: 'Idaho',
            country_code: 'US',
            state_code: 'ID'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac638139'
            },
            name: 'Illinois',
            country_code: 'US',
            state_code: 'IL'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac63813a'
            },
            name: 'Indiana',
            country_code: 'US',
            state_code: 'IN'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac63813b'
            },
            name: 'Iowa',
            country_code: 'US',
            state_code: 'IA'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac63813c'
            },
            name: 'Jarvis Island',
            country_code: 'US',
            state_code: 'UM-86'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac63813d'
            },
            name: 'Johnston Atoll',
            country_code: 'US',
            state_code: 'UM-67'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac63813e'
            },
            name: 'Kansas',
            country_code: 'US',
            state_code: 'KS'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac63813f'
            },
            name: 'Kentucky',
            country_code: 'US',
            state_code: 'KY'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac638140'
            },
            name: 'Kingman Reef',
            country_code: 'US',
            state_code: 'UM-89'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac638141'
            },
            name: 'Louisiana',
            country_code: 'US',
            state_code: 'LA'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac638142'
            },
            name: 'Maine',
            country_code: 'US',
            state_code: 'ME'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac638143'
            },
            name: 'Maryland',
            country_code: 'US',
            state_code: 'MD'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac638144'
            },
            name: 'Massachusetts',
            country_code: 'US',
            state_code: 'MA'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac638145'
            },
            name: 'Michigan',
            country_code: 'US',
            state_code: 'MI'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac638146'
            },
            name: 'Midway Atoll',
            country_code: 'US',
            state_code: 'UM-71'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac638147'
            },
            name: 'Minnesota',
            country_code: 'US',
            state_code: 'MN'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac638148'
            },
            name: 'Mississippi',
            country_code: 'US',
            state_code: 'MS'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac638149'
            },
            name: 'Missouri',
            country_code: 'US',
            state_code: 'MO'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac63814a'
            },
            name: 'Montana',
            country_code: 'US',
            state_code: 'MT'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac63814b'
            },
            name: 'Navassa Island',
            country_code: 'US',
            state_code: 'UM-76'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac63814c'
            },
            name: 'Nebraska',
            country_code: 'US',
            state_code: 'NE'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac63814d'
            },
            name: 'Nevada',
            country_code: 'US',
            state_code: 'NV'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac63814e'
            },
            name: 'New Hampshire',
            country_code: 'US',
            state_code: 'NH'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac63814f'
            },
            name: 'New Jersey',
            country_code: 'US',
            state_code: 'NJ'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac638150'
            },
            name: 'New Mexico',
            country_code: 'US',
            state_code: 'NM'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac638151'
            },
            name: 'New York',
            country_code: 'US',
            state_code: 'NY'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac638152'
            },
            name: 'North Carolina',
            country_code: 'US',
            state_code: 'NC'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac638153'
            },
            name: 'North Dakota',
            country_code: 'US',
            state_code: 'ND'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac638154'
            },
            name: 'Northern Mariana Islands',
            country_code: 'US',
            state_code: 'MP'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac638155'
            },
            name: 'Ohio',
            country_code: 'US',
            state_code: 'OH'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac638156'
            },
            name: 'Oklahoma',
            country_code: 'US',
            state_code: 'OK'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac638157'
            },
            name: 'Oregon',
            country_code: 'US',
            state_code: 'OR'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac638158'
            },
            name: 'Palmyra Atoll',
            country_code: 'US',
            state_code: 'UM-95'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac638159'
            },
            name: 'Pennsylvania',
            country_code: 'US',
            state_code: 'PA'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac63815a'
            },
            name: 'Puerto Rico',
            country_code: 'US',
            state_code: 'PR'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac63815b'
            },
            name: 'Rhode Island',
            country_code: 'US',
            state_code: 'RI'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac63815c'
            },
            name: 'South Carolina',
            country_code: 'US',
            state_code: 'SC'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac63815d'
            },
            name: 'South Dakota',
            country_code: 'US',
            state_code: 'SD'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac63815e'
            },
            name: 'Tennessee',
            country_code: 'US',
            state_code: 'TN'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac63815f'
            },
            name: 'Texas',
            country_code: 'US',
            state_code: 'TX'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac638160'
            },
            name: 'United States Minor Outlying Islands',
            country_code: 'US',
            state_code: 'UM'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac638161'
            },
            name: 'United States Virgin Islands',
            country_code: 'US',
            state_code: 'VI'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac638162'
            },
            name: 'Utah',
            country_code: 'US',
            state_code: 'UT'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac638163'
            },
            name: 'Vermont',
            country_code: 'US',
            state_code: 'VT'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac638164'
            },
            name: 'Virginia',
            country_code: 'US',
            state_code: 'VA'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac638165'
            },
            name: 'Wake Island',
            country_code: 'US',
            state_code: 'UM-79'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac638166'
            },
            name: 'Washington',
            country_code: 'US',
            state_code: 'WA'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac638167'
            },
            name: 'West Virginia',
            country_code: 'US',
            state_code: 'WV'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac638168'
            },
            name: 'Wisconsin',
            country_code: 'US',
            state_code: 'WI'
          }, {
            _id: {
              $oid: '61ade3ff1d72c175ac638169'
            },
            name: 'Wyoming',
            country_code: 'US',
            state_code: 'WY'
          }]

      states.map(async (row, index) => {
        await this.insertStateRecords(row.name, row.country_code, row.state_code)
        console.log(row)
      })
       await this.insertCountryRecords('United state of America', 'US')
      await this.insertCountryRecords('Canada', 'CA')

    }, */
    runAlert (message, type) {
      this.type = type
      this.alertMessage = message
      this.dialogModal = true
    }
  },
  components: {
    ProfessionalInfoUpdate,
    BasicInfoUpdate,
    PasswordUpdate,
    AddressUpdate,
    AvatarUpdate
  }
}
</script>
